import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import {
  SebraetecIcon,
  PeopleIcon,
  ComputerIcon,
  SlideIcon
} from '../../../../components/ui/icons';
import CategoryTab from './components/CategoryTab';
import styles from './CategoryTabs.module.css';

const CATEGORIES = [
  {
    id: 'sebraetec',
    labelKey: 'CATEGORY_SEBRAETEC_LABEL',
    subKey: 'CATEGORY_SEBRAETEC_SUB',
    Icon: SebraetecIcon,
    indicadorAttr: 'possuiVinculosSebraetec',
    href: '/catalogo?tipo=sebraetec'
  },
  {
    id: 'consultoria',
    labelKey: 'CATEGORY_CONSULTORIA_LABEL',
    subKey: 'CATEGORY_CONSULTORIA_SUB',
    Icon: PeopleIcon,
    indicadorAttr: 'possuiConsultorias',
    href: '/catalogo?tipo=consultoria'
  },
  {
    id: 'solucoes',
    labelKey: 'CATEGORY_SOLUCOES_LABEL',
    subKey: 'CATEGORY_SOLUCOES_SUB',
    Icon: SlideIcon,
    indicadorAttr: 'possuiSolucoesDigitais',
    href: '/catalogo?tipo=saas'
  },
  {
    id: 'curso',
    labelKey: 'CATEGORY_CURSO_LABEL',
    subKey: 'CATEGORY_CURSO_SUB',
    Icon: ComputerIcon,
    indicadorAttr: 'possuiCursosOnline',
    href: '/catalogo?tipo=curso'
  }
];

function CategoryTabs({ loading, indicadoresProdutos }) {
  const { t } = useTranslation('home');

  const showBtnSearch = attr =>
    indicadoresProdutos && indicadoresProdutos[attr] && !loading;

  const showComingSoon = attr =>
    indicadoresProdutos &&
    indicadoresProdutos[attr] !== undefined &&
    !indicadoresProdutos[attr] &&
    !loading;

  return (
    <section className={styles.root}>
      <div className={styles.container}>
        <div className={styles.strip}>
          {CATEGORIES.map((cat, i) => (
            <CategoryTab
              key={cat.id}
              Icon={cat.Icon}
              title={t(cat.labelKey)}
              subtitle={t(cat.subKey)}
              href={cat.href}
              loading={loading}
              showBtnSearch={showBtnSearch(cat.indicadorAttr)}
              showComingSoon={showComingSoon(cat.indicadorAttr)}
              isLast={i === CATEGORIES.length - 1}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

CategoryTabs.propTypes = {
  loading: PropTypes.bool,
  indicadoresProdutos: PropTypes.object
};

export default CategoryTabs;
